export const ONBOARDING_STEP_LABELS: Record<string, string> = {
  email_sent_import: 'Importing sent emails',
  calendar_import: 'Importing calendar events',
  writing_style: 'Analyzing writing style',
  user_context: 'Learning about you',
  communication_patterns: 'Analyzing communication patterns',
  business_context: 'Understanding your business',
  pipeline_template_proposal: 'Setting up your pipeline',
  team_invite_proposal: 'Preparing team invitations',
  welcome_proposal: 'Creating welcome actions',
  review_permissions_proposal: 'Reviewing permissions',
  welcome_insights: 'Generating insights',
  create_proposals: 'Creating your first actions',
};

export function getStepLabel(stepName: string): string {
  return ONBOARDING_STEP_LABELS[stepName] ?? stepName.replace(/_/g, ' ');
}

// Steps that share a single display label when shown together
const STEP_GROUPS: Array<{ steps: Set<string>; label: string }> = [
  {
    steps: new Set(['email_sent_import']),
    label: 'Importing emails',
  },
  {
    steps: new Set(['create_proposals']),
    label: 'Preparing your first actions',
  },
  {
    steps: new Set(['writing_style', 'communication_patterns']),
    label: 'Analyzing communication style',
  },
  {
    steps: new Set(['user_context', 'business_context']),
    label: 'Understanding your business',
  },
  {
    steps: new Set(['welcome_proposal', 'welcome_insights']),
    label: 'Preparing welcome actions',
  },
];

/** Deduplicate step names into grouped labels. */
export function getGroupedLabels(stepNames: string[]): string[] {
  const seen = new Set<string>();
  const labels: string[] = [];

  for (const name of stepNames) {
    if (seen.has(name)) {
      continue;
    }

    const group = STEP_GROUPS.find(g => g.steps.has(name));
    if (group) {
      for (const s of group.steps) {
        seen.add(s);
      }
      labels.push(group.label);
    } else {
      seen.add(name);
      labels.push(getStepLabel(name));
    }
  }

  return labels;
}
